import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { addToObject, removeFromObject } from '../../utils/immutable';
import { letters } from '../../utils/constants';
import Question from './Question';

class MultipleChoice extends Component {
  constructor(props) {
    super(props);

    props.setPartialCreditValidator(this.partialCreditValidator);
    props.setReviewSheet(this.renderReviewChunk);
  }

  getSelectedOptions = question => {
    const { input } = this.props;

    if (input && question in input) {
      return input[question];
    }
    if (this.props.data.inputType === 'checkbox') {
      return [];
    }
    return null;
  };

  isQuestionReadyForSubmit = (data, payload) => {
    const minOptions =
      typeof data.minOptions !== 'undefined' ? data.minOptions : 1;
    return (
      !minOptions ||
      (minOptions === 1 && payload) ||
      (payload instanceof Array && payload.length >= minOptions)
    );
  };

  handleClick = (question, options) => {
    const { input, onInput, setSubmitStatus } = this.props;

    const payload =
      options === null
        ? removeFromObject(input, question)
        : addToObject(input, question, options);
    onInput(payload);

    if (this.isGroup()) {
      setSubmitStatus(
        this.props.data.every(question => {
          return this.isQuestionReadyForSubmit(
            question,
            payload[question.question]
          );
        })
      );
    } else {
      setSubmitStatus(
        this.isQuestionReadyForSubmit(this.props.data, payload[question])
      );
    }
  };

  isGroup = () => {
    return Array.isArray(this.props.data);
  };

  partialCreditValidator = (input, correctInput) => {
    if (this.isGroup()) {
      console.warn(
        'Partial credit not implemented for MultipleChoice question groups!'
      );
      return false;
    }

    if (this.props.data.inputType === 'checkbox') {
      let checksMissed = 0;
      let incorrectsChecked = 0;

      Object.keys(correctInput).forEach(question => {
        correctInput[question].forEach(answer => {
          if (!input[question].includes(answer)) checksMissed++;
        });
      });
      Object.keys(input).forEach(question => {
        input[question].forEach(answer => {
          if (!correctInput[question].includes(answer)) incorrectsChecked++;
        });
      });

      if (
        (checksMissed === 0 && incorrectsChecked < 2) ||
        (incorrectsChecked === 0 && checksMissed < 2)
      ) {
        return true;
      }
    }
    return false;
  };

  renderReviewChunk = () => {
    // Because of the design requirements for the review answer sheet, each TEI is going to be displayed differently.
    // Because of this, generating the review sheet JSX in each TEI, and then sending that down the line, allows us
    // to customize how we're building each review segment by TEI type.
    const { data, correctInput } = this.props;
    let correctAnswers = [];
    let answerString = '';
    if (data.inputType === 'checkbox') {
      data.options.forEach((option, index) => {
        correctInput[data.question].forEach(correctAnswer => {
          if (option.label === correctAnswer) {
            correctAnswers.push(letters[index]);
          }
        });
      });

      correctAnswers.forEach((answer, index) => {
        if (index === correctAnswers.length - 1 && correctAnswers.length > 1) {
          answerString = answerString + 'and ' + answer;
        } else {
          answerString = answerString + answer + ', ';
        }
      });
    } else {
      data.options.forEach((option, index) => {
        if (option.label === correctInput[data.question]) {
          answerString = letters[index];
        }
      });
    }

    return (
      <div>
        <p className="review-question">{data.question}</p>
        {data.options.map((option, index) => {
          return (
            <p key={index} className="review-option">
              {letters[index]}. {option.label}
            </p>
          );
        })}
        <p className="review-correct">
          Correct Answer{correctAnswers.length > 1 ? 's' : ''}: {answerString}
        </p>
      </div>
    );
  };

  render() {
    const { data, correctInput } = this.props;

    const renderQuestion = data => (
      <Question
        data={data}
        onClick={this.handleClick}
        input={this.getSelectedOptions(data.question)}
        correctInput={correctInput && correctInput[data.question]}
        validationResult={this.props.validationResult}
        isFinalAttempt={this.props.isFinalAttempt}
      />
    );

    if (this.isGroup()) {
      return data.map((question, i) => (
        <Fragment key={i}>{renderQuestion(question)}</Fragment>
      ));
    } else {
      return renderQuestion(data);
    }
  }
}

MultipleChoice.defaultProps = {
  correctInput: null,
  input: null,
  validationResult: null
};

MultipleChoice.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  correctInput: PropTypes.object,
  input: PropTypes.object,
  onInput: PropTypes.func.isRequired,
  setSubmitStatus: PropTypes.func.isRequired,
  validationResult: PropTypes.bool
};

export default MultipleChoice;



// WEBPACK FOOTER //
// ../core/src/components/MultipleChoice/MultipleChoice.js